import React from "react";
import { Helmet } from "react-helmet";

export default function SeoMeta({ lang = "en" }) {
  const isArabic = lang === "ar";

  const meta = {
    en: {
      title: "Satah Hydraulic Al Khobar Dhahran | سطحة الخبر الظهران  هيدروليك | 0555632801",
      description: "Best satah hydraulic (سطحة هيدروليك) in Khobar & Dhahran. 24/7 emergency towing service, 10-min response. Licensed & insured. Serving Dammam & Eastern Province. Call now!",
      keywords: "satah hydraulic Khobar, سطحة هيدروليك الخبر, satah hydraulic Dhahran, سطحة هيدروليك الظهران, سطحة الخبر, سطحة الظهران, Al Faraj towing, سطحة الدمام, emergency towing Dammam, flatbed towing Dhahran, سطحة الجبيل, vehicle recovery Jubail, سطحة الأحساء, car towing Al-Hasa, towing service Saudi Arabia, 24/7 towing Eastern Province, accident recovery Khobar, شركة الفرج للسطحة, hydraulic flatbed Saudi, سحب السيارات الخبر, سطحة هيدروليك, satah hydraulic",
      image: "https://www.satahalfaraj.com/img1.jpg",
      url: "https://www.satahalfaraj.com",
      ogTitle: "Satah Hydraulic Al Khobar Dhahran | سطحة هيدروليك الخبر الظهران | Best Service 24/7",
      ogDescription: "Top-rated satah hydraulic (سطحة هيدروليك) in Khobar & Dhahran. 10-min response • Modern equipment • Licensed drivers • 24/7 service in Eastern Province. Call now!",
      headerTitle: "Al Faraj Towing Services – Reliable Satah Hydraulic in Khobar & Dhahran",
      headerSubtitle: "Your trusted 24/7 satah hydraulic (سطحة هيدروليك) partner based in Khobar & Dhahran, providing services across Dammam, Al-Hasa, Jubail, Abqaiq, Al Batha, Al Salwa, Riyadh, Jeddah, and Madina. We offer fast, safe, and professional hydraulic flatbed towing and vehicle recovery whenever you need help on the road."
    },
    ar: {
      title: "سطحة الخبر الظهران  هيدروليك| Satah Hydraulic Khobar Dhahran | 0555632801",
      description: "أفضل سطحة هيدروليك في الخبر والظهران. خدمة طوارئ 24/7، استجابة 10 دقائق. مرخص ومؤمن. نخدم الدمام والمنطقة الشرقية. اتصل الآن! Best satah hydraulic in Khobar & Dhahran.",
      keywords: "سطحة هيدروليك الخبر, سطحة هيدروليك الظهران, سطحة الخبر, سطحة الظهران, سطحة الدمام, شركة الفرج, سطحة هيدروليك, satah hydraulic Khobar, satah hydraulic Dhahran, سطحة طوارئ, إنقاذ السيارات, سحب السيارات, سطحة الجبيل, سطحة الأحساء, Al Faraj Towing, hydraulic towing, سطحة 24 ساعة, سطحة المنطقة الشرقية, سطحة هيدروليك مسطحة, سطحة حديثة, خدمة سطحة سريعة, سطحة احترافية",
      image: "https://www.satahalfaraj.com/img1.jpg",
      url: "https://www.satahalfaraj.com/ar",
      ogTitle: "سطحة الخبر الظهران هيدروليك | شركة الفرج | أفضل خدمة 24/7",
      ogDescription: "أفضل سطحة هيدروليك في الخبر والظهران. استجابة 10 دقائق • معدات حديثة • سائقون مرخصون • خدمة 24/7 بالمنطقة الشرقية. اتصل الآن!",
      headerTitle: "شركة الفرج – خدمات سطحة هيدروليك موثوقة في الخبر والظهران",
      headerSubtitle: "شريكك الموثوق لخدمات السطحة الهيدروليك على مدار الساعة من الخبر والظهران وإلى الدمام، الأحساء، الجبيل، بقيق، البطحاء، السلوى، الرياض، جدة، والمدينة. نقدم خدمات سطحة هيدروليك سريعة وآمنة واحترافية في أي وقت تحتاج فيه إلينا."
    }
  };

  const m = isArabic ? meta.ar : meta.en;
  // Use runtime URL as canonical when available so client-side render matches prerendered pages
  const canonicalUrl = (typeof window !== 'undefined' && window.location)
    ? `${window.location.origin}${window.location.pathname}`
    : m.url;
  return (
    <Helmet htmlAttributes={{ lang, dir: isArabic ? 'rtl' : 'ltr' }}>
      {/* Basic SEO */}
      <title>{m.title}</title>
      <meta name="description" content={m.description} />
      <meta name="keywords" content={m.keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="author" content="Al Faraj Towing Services - شركة الفرج للسطحة" />
      <meta name="revisit-after" content="3 days" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Geo Tags for Khobar & Dhahran */}
      <meta name="geo.region" content="SA-04" />
      <meta name="geo.placename" content="Khobar, Dhahran, Dammam, Eastern Province, Saudi Arabia" />
      <meta name="geo.position" content="26.2172;50.1971" />
      <meta name="ICBM" content="26.2172, 50.1971" />
      
      {/* Arabic-specific meta tags */}
      <meta name="language" content={isArabic ? "Arabic" : "English"} />
      <meta httpEquiv="content-language" content={isArabic ? "ar-SA" : "en-US"} />
      
      {/* Bing/Microsoft Specific Tags */}
      <meta name="msapplication-TileColor" content="#DC2626" />
      <meta name="msapplication-TileImage" content="https://www.satahalfaraj.com/img9.webp" />
      <meta name="msvalidate.01" content="YOUR_BING_VERIFICATION_CODE" />

      {/* Alternate Language Tags */}
      <link rel="alternate" hreflang="en" href="https://www.satahalfaraj.com/" />
      <link rel="alternate" hreflang="ar" href="https://www.satahalfaraj.com/ar" />
      <link rel="alternate" hreflang="x-default" href="https://www.satahalfaraj.com/" />

      {/* Open Graph (Facebook / WhatsApp / LinkedIn / Telegram) */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={m.url} />
      <meta property="og:title" content={m.ogTitle} />
      <meta property="og:description" content={m.ogDescription} />
      <meta property="og:image" content={m.image} />
      <meta property="og:image:secure_url" content={m.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={isArabic ? "سطحة الخبر الظهران هيدروليك - شركة الفرج" : "Satah Hydraulic Khobar Dhahran - Al Faraj Towing"} />
      <meta property="og:locale" content={isArabic ? "ar_SA" : "en_US"} />
      <meta property="og:locale:alternate" content={isArabic ? "en_US" : "ar_SA"} />
      <meta property="og:site_name" content="Al Faraj Hydraulic Towing Services (شركة الفرج للسطحة الهيدروليك)" />
      <meta property="og:phone_number" content="+966555632801" />
      <meta property="business:contact_data:street_address" content="Khobar" />
      <meta property="business:contact_data:locality" content="Khobar" />
      <meta property="business:contact_data:region" content="Eastern Province" />
      <meta property="business:contact_data:postal_code" content="31952" />
      <meta property="business:contact_data:country_name" content="Saudi Arabia" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={m.title} />
      <meta name="twitter:description" content={m.description} />
      <meta name="twitter:image" content={m.image} />
      <meta name="twitter:image:alt" content={isArabic ? "سطحة الخبر الظهران هيدروليك " : "Satah Hydraulic Khobar Dhahran"} />
      <meta name="twitter:site" content="@alfarajtowing" />
      <meta name="twitter:creator" content="@alfarajtowing" />

      {/* LocalBusiness Schema with Aggregate Rating */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Al Faraj Hydraulic Towing Services - شركة الفرج للسطحة الهيدروليك",
        "alternateName": [
          "شركة الفرج لخدمات السطحة الهيدروليك", 
          "Al Faraj Towing", 
          "الفرج للسطحة",
          "سطحة الخبر هيدروليك",
          "سطحة الظهران هيدروليك",
          "Satah Hydraulic Khobar",
          "Satah Hydraulic Dhahran"
        ],
        "description": "${isArabic ? 'خدمة سطحة هيدروليك احترافية 24/7 وإنقاذ المركبات الطارئة في الخبر والظهران والمنطقة الشرقية، المملكة العربية السعودية. استجابة سريعة، معدات حديثة، سائقون مرخصون.' : 'Professional 24/7 hydraulic flatbed towing (سطحة هيدروليك) and emergency vehicle recovery service in Khobar, Dhahran and Eastern Province, Saudi Arabia. Fast response, modern equipment, licensed drivers.'}",
        "image": [
          "https://www.satahalfaraj.com/img1.webp",
          "https://www.satahalfaraj.com/img9.webp"
        ],
        "logo": "https://www.satahalfaraj.com/img9.webp",
        "@id": "${canonicalUrl}",
        "url": "${canonicalUrl}",
        "telephone": "+966555632801",
        "email": "info@satahalfaraj.com",
        "priceRange": "$$",
        "paymentAccepted": ["Cash", "Credit Card", "Bank Transfer"],
        "currenciesAccepted": "SAR",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Khobar",
          "addressLocality": "Khobar",
          "addressRegion": "Eastern Province",
          "postalCode": "31952",
          "addressCountry": "SA"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 26.2172,
          "longitude": 50.1971
        },
        "areaServed": [
          {"@type": "City", "name": "Khobar", "alternateName": "الخبر"},
          {"@type": "City", "name": "Dhahran", "alternateName": "الظهران"},
          {"@type": "City", "name": "Dammam", "alternateName": "الدمام"},
          {"@type": "City", "name": "Al-Hasa", "alternateName": "الأحساء"},
          {"@type": "City", "name": "Jubail", "alternateName": "الجبيل"},
          {"@type": "City", "name": "Abqaiq", "alternateName": "بقيق"},
          {"@type": "City", "name": "Al Batha", "alternateName": "البطحاء"},
          {"@type": "City", "name": "Al Salwa", "alternateName": "السلوى"},
          {"@type": "City", "name": "Qatif", "alternateName": "القطيف"},
          {"@type": "City", "name": "Ras Tanura", "alternateName": "رأس تنورة"}
        ],
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "00:00",
          "closes": "23:59"
        },
        "sameAs": [
          "https://www.satahalfaraj.com",
          "https://wa.me/966555632801"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "250",
          "bestRating": "5",
          "worstRating": "1"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "${isArabic ? 'خدمات السطحة الهيدروليك' : 'Hydraulic Towing Services'}",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "${isArabic ? 'سطحة هيدروليك طوارئ 24/7' : '24/7 Emergency Hydraulic Towing'}",
                "description": "${isArabic ? 'خدمة سطحة هيدروليك طوارئ على مدار الساعة في الخبر والظهران' : 'Round-the-clock emergency hydraulic flatbed towing service in Khobar & Dhahran'}"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "${isArabic ? 'إنقاذ السيارات بعد الحوادث' : 'Accident Recovery'}",
                "description": "${isArabic ? 'إنقاذ احترافي للمركبات بعد الحوادث' : 'Professional vehicle recovery after accidents'}"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "${isArabic ? 'سطحة هيدروليك لمسافات طويلة' : 'Long Distance Towing'}",
                "description": "${isArabic ? 'خدمة سطحة هيدروليك بين المدن في جميع أنحاء المملكة العربية السعودية' : 'Intercity hydraulic towing service across Saudi Arabia'}"
              }
            }
          ]
        }
      }
      `}</script>

      {/* Breadcrumb Schema */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": ${isArabic ? '"الرئيسية"' : '"Home"'},
            "item": "${m.url}"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": ${isArabic ? '"خدمات السطحة الهيدروليك"' : '"Hydraulic Towing Services"'},
            "item": "${m.url}#services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": ${isArabic ? '"مناطق الخدمة"' : '"Service Areas"'},
            "item": "${m.url}#areas"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": ${isArabic ? '"اتصل بنا"' : '"Contact Us"'},
            "item": "${m.url}#contact"
          }
        ]
      }
      `}</script>

      {/* FAQ Schema - Enhanced with Arabic */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": ${isArabic ? '"كم من الوقت يستغرق وصول سطحة هيدروليك في الخبر والظهران؟"' : '"How fast can satah hydraulic arrive in Khobar and Dhahran?"'},
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ${isArabic ? '"داخل الخبر والظهران، نصل عادةً في غضون 10-20 دقيقة بسطحاتنا الهيدروليك الحديثة. للمناطق القريبة مثل الدمام، وقت الاستجابة 15-25 دقيقة. نعمل 24/7 لخدمات السطحة الهيدروليك الطارئة."' : '"Within Khobar and Dhahran, we typically arrive in 10-20 minutes with our modern satah hydraulic trucks. For nearby areas like Dammam, response time is 15-25 minutes. We operate 24/7 for emergency hydraulic towing services."'}
            }
          },
          {
            "@type": "Question",
            "name": ${isArabic ? '"ما هي السطحة الهيدروليك ولماذا هي أفضل؟"' : '"What is satah hydraulic and why is it better?"'},
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ${isArabic ? '"السطحة الهيدروليك (satah hydraulic) تستخدم أنظمة هيدروليك متقدمة توفر تحميل وتفريغ سلس ومتحكم به للمركبات. هذا يضمن نقلاً أكثر أمانًا مع الحد الأدنى من مخاطر التلف مقارنة بطرق السحب التقليدية. إنها مثالية للسيارات الفاخرة والمتضررة وإنقاذ الحوادث في الخبر والظهران."' : '"Satah hydraulic (سطحة هيدروليك) uses advanced hydraulic flatbed systems that provide smooth, controlled loading and unloading of vehicles. This ensures safer transport with minimal risk of damage compared to traditional towing methods. It is ideal for luxury vehicles, damaged cars, and accident recovery in Khobar and Dhahran."'}
            }
          },
          {
            "@type": "Question",
            "name": ${isArabic ? '"هل تقدمون خدمة سطحة هيدروليك 24/7 في الخبر والظهران؟"' : '"Do you provide 24/7 satah hydraulic service in Khobar and Dhahran?"'},
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ${isArabic ? '"نعم! شركة الفرج لخدمات السطحة الهيدروليك تعمل 24 ساعة في اليوم، 7 أيام في الأسبوع، بما في ذلك العطلات في الخبر والظهران والدمام وجميع أنحاء المنطقة الشرقية. اتصل بنا في أي وقت على 0555632801 للمساعدة الفورية."' : '"Yes! Al Faraj Satah Hydraulic Services operates 24 hours a day, 7 days a week, including holidays in Khobar, Dhahran, Dammam and across Eastern Province. Call us anytime at 0555632801 for immediate assistance."'}
            }
          },
          {
            "@type": "Question",
            "name": ${isArabic ? '"ما المناطق التي تغطيها سطحة هيدروليك الخبر؟"' : '"What areas does Al Faraj Satah Hydraulic Khobar cover?"'},
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ${isArabic ? '"نوفر خدمات السطحة الهيدروليك في جميع أنحاء المنطقة الشرقية بما في ذلك الخبر والظهران والدمام والأحساء والجبيل وبقيق والبطحاء والسلوى والقطيف ورأس تنورة. نقدم أيضًا السطحة الهيدروليك لمسافات طويلة إلى الرياض وجدة والمدينة."' : '"We provide satah hydraulic services throughout Eastern Province including Khobar, Dhahran, Dammam, Al-Hasa, Jubail, Abqaiq, Al Batha, Al Salwa, Qatif, and Ras Tanura. We also offer long-distance hydraulic towing to Riyadh, Jeddah, and Madina."'}
            }
          },
          {
            "@type": "Question",
            "name": ${isArabic ? '"كم تكلفة السطحة الهيدروليك في الخبر والظهران؟"' : '"How much does satah hydraulic cost in Khobar and Dhahran?"'},
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ${isArabic ? '"تختلف تكاليف السطحة الهيدروليك حسب المسافة ونوع المركبة. نقدم أسعار شفافة وتنافسية بدون رسوم مخفية. اتصل على 0555632801 للحصول على عرض سعر فوري بناءً على احتياجاتك المحددة."' : '"Satah hydraulic costs vary based on distance and vehicle type. We offer transparent, competitive pricing with no hidden fees. Call 0555632801 for an instant quote based on your specific needs."'}
            }
          },
          {
            "@type": "Question",
            "name": ${isArabic ? '"ما أنواع السيارات التي يمكن لسطحة هيدروليك نقلها؟"' : '"What types of vehicles can satah hydraulic tow?"'},
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ${isArabic ? '"يمكن لسطحاتنا الهيدروليك المسطحة نقل جميع أنواع المركبات بأمان بما في ذلك السيارات الصغيرة، الدفع الرباعي، السيارات الفاخرة، السيارات الرياضية، والشاحنات الخفيفة. لدينا معدات متخصصة للمركبات المتضررة والمركبات منخفضة الخلوص في الخبر والظهران."' : '"Our satah hydraulic flatbed tow trucks can safely transport all vehicle types including sedans, SUVs, luxury cars, sports cars, and light trucks. We have specialized equipment for accident-damaged vehicles and low-clearance vehicles in Khobar and Dhahran."'}
            }
          }
        ]
      }
      `}</script>

      {/* WebSite Schema for Search Box */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": ${isArabic ? '"شركة الفرج لخدمات السطحة الهيدروليك - الخبر الظهران"' : '"Al Faraj Satah Hydraulic Services - Khobar Dhahran"'},
        "alternateName": ${isArabic ? '"سطحة هيدروليك الخبر الظهران"' : '"Satah Hydraulic Khobar Dhahran"'},
        "url": "${m.url}",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "${m.url}?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }
      `}</script>

      {/* Organization Schema */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Al Faraj Hydraulic Towing Services - شركة الفرج للسطحة الهيدروليك",
        "alternateName": ["شركة الفرج", "سطحة الخبر هيدروليك", "سطحة الظهران هيدروليك", "Satah Hydraulic Khobar", "Satah Hydraulic Dhahran"],
        "url": "https://www.satahalfaraj.com",
        "logo": "https://www.satahalfaraj.com/img9.webp",
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+966555632801",
            "contactType": "Emergency",
            "areaServed": "SA",
            "availableLanguage": ["English", "Arabic"],
            "contactOption": "TollFree"
          },
          {
            "@type": "ContactPoint",
            "telephone": "+966536121365",
            "contactType": "Customer Service",
            "areaServed": "SA",
            "availableLanguage": ["English", "Arabic"]
          }
        ],
        "sameAs": [
          "https://www.satahalfaraj.com",
          "https://wa.me/966555632801"
        ]
      }
      `}</script>

      {/* Service Schema - Hydraulic Towing */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "${isArabic ? 'سطحة هيدروليك - خدمة سحب المركبات' : 'Satah Hydraulic - Vehicle Towing Service'}",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Al Faraj Hydraulic Towing Services",
          "alternateName": "شركة الفرج للسطحة الهيدروليك"
        },
        "areaServed": {
          "@type": "City",
          "name": "Khobar, Dhahran, Dammam",
          "alternateName": "الخبر، الظهران، الدمام"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "${isArabic ? 'خدمات السطحة الهيدروليك' : 'Hydraulic Towing Services'}",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "${isArabic ? 'سطحة هيدروليك طوارئ' : 'Emergency Satah Hydraulic'}"
              }
            }
          ]
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "servicePhone": {
            "@type": "ContactPoint",
            "telephone": "+966555632801",
            "availableLanguage": ["Arabic", "English"]
          }
        }
      }
      `}</script>
    </Helmet>
  );
}

/* 
  ✅ Enhanced Arabic SEO Features:
  - Primary focus: سطحة هيدروليك الخبر الظهران (Satah Hydraulic Khobar Dhahran)
  - Bilingual titles for better reach
  - Enhanced Arabic keywords and meta descriptions
  - Structured data in both languages
  - Optimized for Saudi Arabia searches
  - All major cities covered (Khobar, Dhahran, Dammam, etc.)
  - Schema markup enhanced with Arabic alternateNames
  - Better local SEO optimization
  - No duplicate meta tags
  - Supports all search engines (Google, Bing, Yandex, Baidu, Naver)
*/